import { useState } from 'react';
import { isEmpty } from 'lodash';
import { useQueryCheckExistenceOfInvoice } from 'containers/SaleDetail/graphQL/hooks/useQueryCheckExistenceOfInvoice';
import { Delivery, TransactionState, TransactionType } from 'types/api';
import { useMutationTicketsSale } from 'containers/SaleDetail/graphQL/hooks/useMutationTicketsSale';

export const useDeliveryDetailHooks = (selectedDelivery: Delivery) => {
  const { handleCheckExistenceOfInvoice } = useQueryCheckExistenceOfInvoice();
  const { handleRequestCancelOrders, handleRetractCancelOrderRequests } =
    useMutationTicketsSale();

  const orderItems = selectedDelivery && selectedDelivery.order.items;
  const isCancelDelivery =
    orderItems &&
    orderItems.every(
      item =>
        !isEmpty(item.dependedItems) &&
        item.dependedItems.every(
          dependItem =>
            (dependItem.transaction.status === TransactionState.REQUESTED &&
              dependItem.transaction.type === TransactionType.CANCELLATION) ||
            (dependItem.transaction.status === TransactionState.COMPLETED &&
              dependItem.transaction.type === TransactionType.CANCELLATION),
        ),
    );

  const [isOpenConfirmDialog, setIsOpenConfirmDialog] =
    useState<boolean>(false);
  const [isOpenRetreatDialog, setIsOpenRetreatDialog] =
    useState<boolean>(false);
  const [isOpenCancelModal, setIsOpenCancelModal] = useState<boolean>(false);

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(
      selectedDelivery.recipient.address.roadAddress,
    );

    window.showToast('주소가 복사되었습니다.', 'success', 3000);
  };

  const handleOpenConfirmDialog = () => {
    setIsOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setIsOpenConfirmDialog(false);
  };

  const handleOpenRetreatDialog = () => {
    setIsOpenRetreatDialog(true);
  };

  const handleCloseRetreatDialog = () => {
    setIsOpenRetreatDialog(false);
  };

  const handleOpenCancelModal = () => {
    setIsOpenCancelModal(true);
  };

  const handleCloseCancelModal = () => {
    setIsOpenCancelModal(false);
  };

  const handleRequestCancel = () => {
    orderItems.forEach(item => {
      item.units.forEach(unit => {
        handleCheckExistenceOfInvoice(
          {
            orderItemId: item.id,
            indexNo: unit.indexNo,
          },
          () => {
            handleOpenCancelModal();
          },
        );
      });
    });
  };

  return {
    isOpenConfirmDialog,
    isOpenRetreatDialog,
    isOpenCancelModal,
    isCancelDelivery,
    handleRequestCancelOrders,
    handleRetractCancelOrderRequests,
    handleCopyAddress,
    handleOpenConfirmDialog,
    handleCloseConfirmDialog,
    handleOpenRetreatDialog,
    handleCloseRetreatDialog,
    handleCloseCancelModal,
    handleRequestCancel,
  };
};
